import PropTypes from "prop-types";
import {PurchaseBodyFooter} from "./PurchaseBodyFooter";
import {PurchaseBodyHeader} from "./PurchaseBodyHeader";
import {PurchaseBodyContent} from "./PurchaseBodyContent";


export function PurchaseBody(props) {
    return (
        <>
            <div className=" w-screen m-3">
                <table className="table table-striped w-full table-responsive-sm table-sm ">

                    <PurchaseBodyHeader/>

                    <tbody>
                    <PurchaseBodyContent contentList={props.list} setContentList={props.setList}
                                         custometId={props.customerId}
                                         priceEnable={true} rowEnable={props.enableRowEdit}
                                         isPosted={props.isPosted} customerId={props.customerId}
                                         invoiceId={props.invoiceId} setLoading={props.setLoading}
                                         loading={props.loading} itemList={props.itemList}/>
                    </tbody>
                    <tfoot style={{backgroundColor: "orange"}} className="border-round-md">
                    <PurchaseBodyFooter contentList={props.list} setLoading={props.setLoading} vat={props.vat}/>
                    </tfoot>

                </table>
            </div>

        </>
    )
}

PurchaseBody.propTypes = {
    setList: PropTypes.func.isRequired,
    enableGlobalEdit: PropTypes.bool.isRequired,
    enableRowEdit: PropTypes.bool.isRequired,
    customerId: PropTypes.number.isRequired,
    invoiceId: PropTypes.number.isRequired,
    list: PropTypes.array.isRequired,
    setLoading: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    itemList: PropTypes.array.isRequired,
    isPosted: PropTypes.bool.isRequired,
    vat: PropTypes.number.isRequired,
}


